import api from './api';

export interface Invoice {
  id: number;
  student: number;
  teacher?: number;
  teacher_name?: string;
  is_foreign?: boolean;
  date: string;
  start_time: string;
  end_time: string;
  price: number;
  discount?: number;
  discount_label?: string;
  status: 'draft' | 'issued' | 'paid';
  payment_method?: 'cheque' | 'cash' | 'transfer' | 'card' | 'nature';
  payment_date?: string;
  pdf_file?: string;
  pdf_file_url?: string;
  created_at: string;
  updated_at: string;
}

class InvoiceService {
  async getAll(params?: any): Promise<Invoice[]> {
    const response = await api.get('/invoices/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getByStudent(studentId: number): Promise<Invoice[]> {
    const response = await api.get('/invoices/', { params: { student: studentId } });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getInvoice(id: number): Promise<Invoice> {
    const response = await api.get(`/invoices/${id}/`);
    return response.data;
  }

  async create(data: Partial<Invoice>): Promise<Invoice> {
    const response = await api.post('/invoices/', data);
    return response.data;
  }

  async update(id: number, data: Partial<Invoice>): Promise<Invoice> {
    const response = await api.patch(`/invoices/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/invoices/${id}/`);
  }

  async generatePdf(id: number): Promise<any> {
    const response = await api.post(`/invoices/${id}/generate-pdf/`);
    return response.data;
  }

  async downloadPdf(id: number): Promise<Blob> {
    const response = await api.get(`/invoices/${id}/download-pdf/`, {
      responseType: 'blob'
    });
    return response.data;
  }

  async batchMarkPaid(data: {
    invoice_ids: number[];
    student_id: number;
    payment_method: string;
    discount?: number;
    discount_label?: string;
  }): Promise<{ success: boolean; global_invoice_id: number; message: string }> {
    const response = await api.post('/invoices/batch-mark-paid/', data);
    return response.data;
  }
}

const invoiceService = new InvoiceService();
export default invoiceService;
